import Parse from "parse";

Parse.initialize("openinc");
Parse.serverURL = "https://mobilenergy.openinc.de/parse";
